import PropTypes from 'prop-types';

export default PropTypes.shape({
  currentActive: PropTypes.bool,
  reasonCode: PropTypes.string,
  priority: PropTypes.number,
  override: PropTypes.bool,
  active: PropTypes.bool
});
